import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { AccountSettingsMobileTabContents } from "@pages/account-settings/account-settings-layout/mobile-layout/account-settings-mobile-tab-contents";
import { AccountSettingsMobileTabSelection } from "@pages/account-settings/account-settings-layout/mobile-layout/account-settings-mobile-tab-selection";
/** Layout for account settings in mobile view */
export function AccountSettingsMobileLayout(t0) {
  const $ = _c(3);
  const {
    tabs,
    selectedTabId
  } = t0;
  let t1;
  if ($[0] !== selectedTabId || $[1] !== tabs) {
    t1 = <Box component="div">{selectedTabId === undefined ? <AccountSettingsMobileTabSelection tabs={tabs} /> : <AccountSettingsMobileTabContents tabs={tabs} selectedTabId={selectedTabId} />}</Box>;
    $[0] = selectedTabId;
    $[1] = tabs;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}